import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-background-music`;

export const GetMusicListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall" }),
    });

    if (!response.ok) throw new Error("Failed to fetch music list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteMusic = async (musicId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Music?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: { action: "delete", _id: musicId } }),
      });

      const data = await response.json();
      if (data.success) {
        toast.success("Music deleted successfully");
        refreshCallback();
      } else {
        toast.error(data.message || "Failed to delete");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitMusicApi = async (musicData) => { 
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify({
      action: musicData._id ? "edit" : "add",
      _id: musicData._id,
      meditation_background_music_category: musicData.meditation_background_music_category,
    }));

    if (musicData.audioFile) {
      formData.append("audioFile", musicData.audioFile);
    }

    const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      toast.success(musicData._id ? "Music updated successfully" : "Music added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save music");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the music");
    return null;
  }
};

export const getMusicByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: { action: "getById", _id: id } }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load music");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
